import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Dialog from 'cityads-v3/components/Dialog/Dialog';

import config from 'cityads-v3/config';

import { sassExportsToObjectRecursive } from 'cityads-v3/utils/styleUtils';
import classes from "./WelcomeDialog.scss";

const sassExports = sassExportsToObjectRecursive(classes);

@withTranslation(['main'], { i18n, wait: false })
export default class WelcomeDialog extends Component {

  static propTypes = {
    onRequestClose: PropTypes.func,
  }

  getWelcomeDialogTabs() {
    const { t } = this.props;
    const tabs = [
      {
        value: 'enter',
        label: t('enter'),
        cta: t('authWelcome'),
        children: (
          <div className={classes.welcome}>
            <Icon color="primary" {...sassExports.iconStyles}>check_circle</Icon><br/>
            {t('alreadyRegistered')}<br/><br/>

            <Button
              variant = "contained"
              color   = "primary"
              href    = {`${config.AUTH_URL}/enter`}
              rel     = "nofollow"
            >{t('authWelcomeAccount')}</Button>
          </div>
        )
      },
    ];

    return tabs;
  }

  render() {
    return (
      <Dialog
        open           = {true}
        onRequestClose = {this.props.onRequestClose}
        closeLink      = {this.props.closeLink}
        tab            = "enter"
        tabs           = {this.getWelcomeDialogTabs()}
      />
    );
  }

}
